import styled from "styled-components";

export const Content = styled.div`
  max-height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  video {
    width: 100%;
    max-height: 60vh;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    video {
      max-height: 50vh;
    }
  }
`;


export const Video = styled.video`
    width: 100%;
    height: auto;

    @media (max-width: 900px) {
        max-height: 90%;
    }

`;